var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[(!this.$store.getters['auth/authenticated'])?_c('span',{},[(_vm.isLogInShown)?_c('Login'):_c('SignUp')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }